import { match } from 'ts-pattern';

export async function watchPermission(
    name: PermissionName,
    handleChange: (permissionGranted: boolean) => void,
    signal: AbortSignal,
) {
    if (!navigator.permissions?.query) {
        return;
    }

    try {
        const permission = await navigator.permissions.query({ name });
        permission.addEventListener(
            'change',
            () =>
                match(permission.state)
                    .with('denied', () => handleChange(false))
                    .with('granted', () => handleChange(true)),
            { signal },
        );

        if (permission.state === 'denied') {
            handleChange(false);
        }
    } catch {
        console.warn(`Permission ${name} is not supported.`);
    }
}
